import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export const uploadProfilePicture = withNextApi<
  ProfilePictureSaveResponse,
  UploadProfilePictureParameters
>("/cvp/CvpUploadPicture");

export interface UploadProfilePictureParameters extends NextApiParams {
  formData: FormData;
}

export interface ProfilePictureSaveResponse extends BackendResponse {
  IdBilder: number;
}
